import React, { Component } from 'react'
import { Icon, Input, Spin, Modal, Button, notification, Tag, message } from "antd"
import PopupConfirm from "./PopupConfirm"
import PopupReceivedSewing from "./PopupReceivedSewing"
import { getInformationBatchByNameV2, updateStatusBatchV2, updateBatchReceiveSewName, markBatchSewed, callActionApi, getSewingThreadWarning } from "../../../services/api/3dApi"
import { getLocalData } from "../../../services/StorageServices"
import { parseJwt } from "../../../helpers/parseToken"
import AdditionalModal from './AdditionalModal'
import { logoutUser } from "../../../services/AuthServices"
import { withRouter } from "react-router-dom"
import _ from 'lodash'
import SewingThreadWarning from './SewingThreadWarning'

class UpdateBatchesPageNew extends Component {
    state = {
        getLoading: false,
        updateLoading: false,
        // message: '',
        showModal: '',
        visible: false,
        // disable: true,
        batchs: [],
        nextStatus: '',
        scanValue: '',
        cacheValue: '',
        valueInput: '',
        errorInput: '',
        partnerSewingId: '',
        giveSewName: '',
        receiveSewName: '',
        material_weight: '',
        isBtnReceiveSew: false,
        nextStage: '',
        additionalPayLoad: {},
        isTheBatchGroup: false,
        sewingThreadWarning: null
    }

    _input = React.createRef()

    _resetScanInput = () => {
        this.setState({
            // message: '',
            // disable: true,
            batchs: [],
            scanValue: '',
            valueInput: '',
            partnerSewingId: '',
            giveSewName: '',
            receiveSewName: '',
            material_weight: '',
            isBtnReceiveSew: false,
            nextStage: '',
            additionalPayLoad: {},
            nextStatus: '',
            sewingThreadWarning: null
        }, () => {
            this._input.current.focus()
        })
    }

    _handleChangeSelect = (value) => {
        this.setState({
            partnerSewingId: value
        })
    }

    _handleChangeInput = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    _onChangeAdditional = (field, value) => {
        const { additionalPayLoad } = { ...this.state }
        this.setState({
            additionalPayLoad: {
                ...additionalPayLoad,
                [field]: value
            }
        })
    }

    _handleChangeScan = (e) => {
        let { value } = e.target

        this.setState({
            // message: '',
            errorInput: '',
            valueInput: value
        })
    }

    _onSubmit = (e) => {
        e.preventDefault()

        const { valueInput } = this.state
        const check = /^\w+-\d/.test(valueInput)

        this.setState({
            // message: '',
            // disable: true,
            // batchs: [],
            errorInput: !check ? 'Mã lô sai định dạng.' : ''
        }, () => {
            const valueFormatted = valueInput.trim()

            if (!valueFormatted) {
                return this.setState({
                    errorInput: 'Mã lô sai định dạng.'
                })
            }

            check && this._getBatchDetailByName(valueFormatted.toUpperCase())
        })
    }

    _getBatchDetailByName = async (value) => {
        this.setState({
            getLoading: true,
            // message: '',
            scanValue: ''
        })

        try {
            const { data: response } = await getInformationBatchByNameV2({ name: value })
            const { success, data, error } = response || {}
            if (!success) {
                return this.setState({
                    getLoading: false,
                    scanValue: '',
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }

            const { batch, batches, nextStage, inform } = data
            const { additional = [], name: nextStatus = '' } = { ...nextStage }
            const tokenData = getLocalData('accessToken')
            const { username } = !!tokenData ? parseJwt(tokenData) : {}
            const additionalPayLoad = additional.length > 0 && additional.reduce((acc, item) => {
                if(item.key === 'give_sew_name') {
                    acc[item.key] = username
                }else {
                    acc[item.key] = ''
                }
                return acc
            }, {})

            const newBatchs = [...new Map([...this.state.batchs, { ...batch, ...inform }].map(batch => [batch._id, batch])).values()]
            const { status = '', receive_sew_name = '' } = Object.assign({}, batch)
            const isBatchSameStatus = newBatchs.every(i => i.status === status)

            const batchesOfGroup = batches && Object.keys(batches).length > 0 ? Object.values(batches).map(({ batch, nextStage }) => ({ ...batch, nextStage })) : [];
            // logic for batch group
            if (batchesOfGroup.length > 0) {
                const hasReceiveSewNameBatch = batchesOfGroup.some(b => {
                    const { receive_sew_name: rsn = '' } = b || {}
                    return !!rsn
                })
                if (hasReceiveSewNameBatch) {
                    return this.setState({
                        getLoading: false,
                    }, () => {
                        Modal.error({
                            title: 'Lỗi',
                            content: 'Có lô đã nhận may. Không được phép cập nhật trạng thái lô!',
                            okText: 'Đóng'
                        })
                    })
                }
                const newBatches = batchesOfGroup.map(b => ({
                    ...b,
                    ...((batches[b._id] || {}).inform || {}),
                    disabled: true
                }))
                this.setState({
                    getLoading: false,
                    batchs: newBatches,
                    nextStatus: nextStatus,
                    nextStage: nextStage,
                    additionalPayLoad: additionalPayLoad,
                    scanValue: '',
                    isTheBatchGroup: true
                }, () => {
                    this._getSewingThreadWarning(newBatches.map(b => b.name))
                })

                return
            }

            // logic for single batch
            if (!!receive_sew_name) {
                return this.setState({
                    getLoading: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: 'Lô đã nhận may. Không được phép cập nhật trạng thái lô!',
                        okText: 'Đóng'
                    })
                })
            }

            if (!isBatchSameStatus) {
                return this.setState({
                    getLoading: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: 'Vui lòng quét các lô cùng trạng thái.',
                        okText: 'Đóng'
                    })
                })
            }

            const finalBatchs = !isBatchSameStatus ? newBatchs.filter(i => i.status !== status) : newBatchs
            this.setState({
                getLoading: false,
                batchs: finalBatchs,
                nextStatus: nextStatus,
                nextStage: nextStage,
                additionalPayLoad: additionalPayLoad,
                scanValue: ''
            }, () => {
                this._getSewingThreadWarning(finalBatchs.map(b => b.name))
                // const isReceiveSewNameBatch = newBatchs.every(batch => {
                //     const { status = '', receive_sew_name = '' } = Object.assign({}, batch)
                //     return status === "sewing" && !!receive_sew_name
                // })

                // if (additional.length > 0) {
                //     this._showModal('additional')
                // } 
                // else if (nextStatus === '' && isReceiveSewNameBatch) {
                //     Modal.error({
                //         title: 'Lỗi',
                //         content: 'Lô đã nhận may. Không được phép cập nhật trạng thái lô!',
                //         okText: 'Đóng'
                //     })
                //     this.setState({ batchs: newBatchs.filter(batch => batch.status !== status) })
                // }
            })
        } catch (e) {
            this.setState({
                getLoading: false
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this.setState({ valueInput: '' })
            this._input.current.focus()
        }
    }

    _getSewingThreadWarning = async (batchNames) => {
        if (!Array.isArray(batchNames) || batchNames.length === 0) {
            return this.setState({ sewingThreadWarning: null })
        }
        try {
            const { data: response } = await getSewingThreadWarning({ batchNames })
            const { success, data } = response || {}
            if (!success) {
                return this.setState({ sewingThreadWarning: null })
            }
            this.setState({ sewingThreadWarning: data })
        } catch (e) {
            console.log(e.message)
            this.setState({ sewingThreadWarning: null })
        }
    }

    _additionalAction = async (api, batchId) => {
        const { url } = { ...api }
        const apiUrl = url.replace(/:[a-zA-Z0-9_]+/, batchId)
        const newApi = { ...api, url: apiUrl }
        try {
            const { data: response } = await callActionApi(newApi)
            const { data, success, error } = response
            if (!success) {
                throw new Error(error)
            }

            const { receive_sew_name, name } = data
            if (apiUrl.includes('/update-receive-sew-name')) {
                notification.success({
                    message: `Lô ${name} đã được cập nhật người nhận may là: ${receive_sew_name}.`,
                })
            } else if (apiUrl.includes('/mark-sewed')) {
                notification.success({
                    message: `Lô ${name} đã được đánh dấu may xong thành công.`,
                })
            } else {
                notification.success({
                    message: `Cập nhật thành công.`,
                })
            }

        } catch (e) {
            throw new Error(e.message)
        }
    }


    _updateStatus = async () => {
        this.setState({
            updateLoading: true
        })

        try {
            const { batchs, isTheBatchGroup } = this.state
            const { nextStatus, partnerSewingId, giveSewName, material_weight, additionalPayLoad, nextStage } = this.state
            const { api: nextStageApi } = { ...nextStage }
            const { mode } = { ...nextStageApi }

            if (mode === 'before') {
                try {
                    await this._additionalAction(nextStageApi, batchs.map(b => b._id))
                } catch (error) {
                    throw new Error(error.message)
                }
            }

            const payload = {
                partner: partnerSewingId,
                status: nextStatus,
                ...additionalPayLoad,
            }
            if (material_weight !== '') payload.material_weight = parseFloat(material_weight)
            if (nextStatus === "Nhận may") {
                const tokenData = getLocalData('accessToken')
                const { username } = !!tokenData ? parseJwt(tokenData) : {}
                payload.receive_sew_name = username
            }
            if (nextStatus === "QC sau ép") {
                payload.force = true
                payload.forceStatus = "wait_to_sew"
            }
            if (isTheBatchGroup) {
                const newPayload = {
                    ...payload,
                }
                if (Array.isArray(batchs) && batchs.length > 0) {
                    newPayload.batchIds = batchs.map(b => b._id)
                }
                const { data, success, error } = await updateStatusBatchV2(newPayload)
                if (!success) {
                    throw new Error(error)
                }
                notification.success({
                    message: `Các lô đã được cập nhật trạng thái ${nextStatus === "QC sau ép" ? "Chờ may" : nextStatus}: ${batchs.map(b => b.name).join(', ')}`,
                })
                return
            }

            const updatePromises = batchs.map((batch) => {
                const newPayload =  {
                    ...payload,
                    batchIds: [batch._id]
                }
                return updateStatusBatchV2(newPayload)
                    .then(response => {
                        const { data, success, error } = response.data
                        if (!success) {
                            return { success: false, batchId: batch._id, error, batchName: batch.name }
                        }
                        return { success: true, batchId: batch._id, name: batch.name }
                    })
                    .catch(e => ({ success: false, batchId: batch._id, error: e.message, batchName: batch.name, response: e.response }))
            })

            const results = await Promise.all(updatePromises)

            const failedUpdates = []
            const successUpdates = []

            results.forEach(result => {
                if (result.success) {
                    successUpdates.push(result.name)
                } else {
                    failedUpdates.push(result)
                }
            })

            const isExpirationToken = failedUpdates.some(i => _.get(i, 'response.status') === 401)

            if (mode === 'after') {
                try {
                    await this._additionalAction(nextStageApi, batchs.map(b => b._id))
                } catch (error) {
                    throw new Error(error.message)
                }
            }

            this.setState({ updateLoading: false }, () => {
                if (failedUpdates.length === 0) {
                    notification.success({
                        message: `Các lô đã được cập nhật trạng thái ${nextStatus === "QC sau ép" ? "Chờ may" : nextStatus}: ${successUpdates.join(', ')}`,
                    })
                } else {
                    Modal.info({
                        title: 'Kết quả cập nhật',
                        content: (
                            <div>
                                {successUpdates.length > 0 && (
                                    <div className="mt-2">
                                        <h5 className="text-success">Cập nhật thành công:</h5>
                                        <ul className="pl-4 list-disc">
                                            {successUpdates.map(name => (
                                                <li key={name}>{name}</li>
                                            ))}
                                        </ul>
                                        <b>Các lô đã được cập nhật trạng thái {nextStatus}.</b>
                                    </div>
                                )}

                                {failedUpdates.length > 0 && (
                                    isExpirationToken ?
                                        <i className='text-danger font-weight-bold'>Hết hạn token, cần đăng nhập lại.</i> :
                                        <div className="mt-2">
                                            <h5 className="text-danger">Có lỗi khi cập nhật các lô:</h5>
                                            <ul className="pl-4 list-disc">
                                                {failedUpdates.map(i => (
                                                    <li key={i.batchId}>{`${i.batchName}: ${i.error}`}</li>
                                                ))}
                                            </ul>
                                        </div>
                                )}
                            </div>
                        ),
                        okText: isExpirationToken ? 'Login' : 'Đóng',
                        onOk: () => {
                            const location = _.get(this.props, 'location.pathname')

                            if (isExpirationToken) {
                                logoutUser(location)
                            }
                        }
                    })
                }

                this._hiddenModal()
                this._resetScanInput()
            })
        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _updateReceiveSewName = async () => {
        const tokenData = getLocalData('accessToken')
        const { username } = !!tokenData ? parseJwt(tokenData) : {}

        if (!username) return

        this.setState({
            updateLoading: true
        })

        try {
            const { batchs } = this.state
            const { receiveSewName } = this.state

            const updatePromises = batchs.map(batch => {
                const payload = {
                    receive_sew_name: username
                }

                return updateBatchReceiveSewName(batch._id, payload)
                    .then(response => {
                        const { data, success, error } = response.data

                        if (!success) {
                            return { success: false, batchId: batch._id, error: error, batchName: batch.name }
                        }
                        return { success: true, batchId: batch._id, name: data.name, receive_sew_name: data.receive_sew_name }
                    })
                    .catch(e => {
                        return { success: false, batchId: batch._id, error: e.message }
                    })
            })

            const results = await Promise.all(updatePromises)

            const failedUpdates = []
            const successUpdates = []

            results.forEach(result => {
                if (result.success) {
                    successUpdates.push(result.name)
                } else {
                    failedUpdates.push(result)
                }
            })

            this.setState({ updateLoading: false }, () => {
                if (failedUpdates.length === 0) {
                    notification.success({
                        message: `Các lô đã được cập nhật người nhận may thành công: ${successUpdates.join(', ')}.`,
                    })
                } else {
                    Modal.info({
                        title: 'Kết quả cập nhật',
                        content: (
                            <div>
                                {successUpdates.length > 0 && (
                                    <div className="mt-2">
                                        <h5 className="text-success">Cập nhật thành công:</h5>
                                        <ul className="pl-4 list-disc">
                                            {successUpdates.map(name => (
                                                <li key={name}>{name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {failedUpdates.length > 0 && (
                                    <div className="mt-2">
                                        <h5 className="text-danger">Có lỗi khi cập nhật các lô:</h5>
                                        <ul className="pl-4 list-disc">
                                            {failedUpdates.map(i => (
                                                <li key={i.batchId}>{`${i.batchName}: ${i.error}`}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ),
                        okText: 'Đóng'
                    })
                }

                this._hiddenModal()
                this._resetScanInput()
            })

        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _showModal = (type) => {
        document.body.classList.add('CustomPopup')

        this.setState({
            showModal: type,
            visible: true
        })
    }

    _hiddenModal = () => {
        document.body.classList.remove('CustomPopup')

        this.setState({
            showModal: '',
            visible: false
        })
    }

    _markBatchSewed = async () => {
        this.setState({
            updateLoading: true,
            scanValue: ''
        })

        try {
            const { batchs } = this.state

            const markPromises = batchs.map(batch => {
                return markBatchSewed(batch._id)
                    .then(response => {
                        const { data, success, error } = response.data
                        if (!success) {
                            return { success: false, batchId: batch._id, error: error, batchName: batch.name }
                        }
                        return { success: true, batchId: batch._id, name: data.name }
                    })
                    .catch(e => {
                        return { success: false, batchId: batch._id, error: e.message }
                    })
            })

            const results = await Promise.all(markPromises)

            const failedUpdates = []
            const successUpdates = []

            results.forEach(result => {
                if (result.success) {
                    successUpdates.push(result.name)
                } else {
                    failedUpdates.push(result)
                }
            })


            this.setState({ updateLoading: false }, () => {
                if (failedUpdates.length === 0) {
                    notification.success({
                        message: `Các lô đã được đánh dấu may xong thành công: ${successUpdates.join(', ')}`,
                    })
                } else {
                    Modal.info({
                        title: 'Kết quả cập nhật',
                        content: (
                            <div>
                                {successUpdates.length > 0 && (
                                    <div className="mt-2">
                                        <h5 className="text-success">Cập nhật thành công:</h5>
                                        <ul className="pl-4 list-disc">
                                            {successUpdates.map(name => (
                                                <li key={name}>{name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {failedUpdates.length > 0 && (
                                    <div className="mt-2">
                                        <h5 className="text-danger">Có lỗi khi cập nhật các lô:</h5>
                                        <ul className="pl-4 list-disc">
                                            {failedUpdates.map(i => (
                                                <li key={i.batchId}>{`${i.batchName}: ${i.error}`}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ),
                        okText: 'Đóng'
                    })
                }

                this._hiddenModal()
                this._resetScanInput()
            })

        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }


    _removeBatch = (batchId) => {
        const { batchs } = this.state
        const newBatchs = batchs.filter(batch => batch._id !== batchId) || []
        if (newBatchs.length === 0) {
            this.setState({
                batchs: newBatchs,
                nextStatus: '',
                sewingThreadWarning: null
            })
        } else {
            this.setState({ batchs: newBatchs }, () => {
                this._getSewingThreadWarning(newBatchs.map(b => b.name))
            })
        }
    }

    render() {
        const {
            getLoading,
            updateLoading,
            showModal,
            visible,
            batchs,
            nextStatus,
            valueInput,
            errorInput,
            partnerSewingId,
            giveSewName,
            material_weight,
            receiveSewName,
            isBtnReceiveSew,
            nextStage,
            additionalPayLoad,
            sewingThreadWarning,
        } = this.state
        const { additional = [], batch_item_state } = { ...nextStage }
        const { key: nextBatchItemStageName } = { ...batch_item_state }

        const totalItems = batchs.reduce((o, i) => {
            const { total_items = 0 } = { ...i }
            return o + total_items
        }, 0)

        const totalAvailableItemsNumber = batchs.reduce((o, i) => {
            const { available_items_number = 0 } = { ...i }
            return o + available_items_number
        }, 0)

        // const isWaitToSewBatchs = batchs.length > 0 && batchs.every(i => !!i.status && i.status === "wait_to_sew")
        // const isSewingBatchs = batchs.length > 0 && batchs.every(i => !!i.status && i.status === "sewing")
        // const isSewedBatchs = batchs.length > 0 && batchs.every(i => {
        //     const { production_meta = {} } = Object.assign({}, i)
        //     const { sewed = {} } = Object.assign({}, production_meta)
        //     return Object.keys(sewed).length > 0
        // })

        return (
            <div className="UpdateBatchesPage">
                <div className="position-relative">
                    <Spin spinning={getLoading} tip='Đang kiểm tra...'>
                        <form onSubmit={this._onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={this._input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={this._handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={this._resetScanInput}
                                />
                            }

                            {
                                getLoading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="batch_tag">
                                    {
                                        batchs.length > 0 &&
                                        batchs.map((batch) => {
                                            return <Tag key={batch._id} closable onClose={() => this._removeBatch(batch._id)}>{batch.name}</Tag>
                                        })
                                    }
                                </div>
                                <div>
                                    {/* {
                                        (!getLoading && !disable && nextStatus !== '') &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-5'
                                            onClick={() => this._showModal('giveSewName')}
                                        >
                                            {message}
                                        </Button>
                                    }

                                    {
                                        (!getLoading && isSewingBatchs && !isSewedBatchs) &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-5'
                                            onClick={() => this._markBatchSewed()}
                                            style={{ fontSize: 20 }}
                                        >
                                            Đánh dấu lô may xong
                                        </Button>
                                    }

                                    {
                                        isBtnReceiveSew && isSewedBatchs &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-5'
                                            onClick={this._updateReceiveSewName}
                                            style={{ fontSize: 20 }}
                                        >
                                            Nhận may
                                        </Button>
                                    } */}

                                    {
                                        !getLoading && !!nextStatus &&
                                        (
                                            ["Nhận may", "Đã may"].includes(nextStatus) ?
                                                <Button
                                                    type='primary'
                                                    className='float-right mt-5'
                                                    onClick={this._updateStatus}
                                                >
                                                    {nextStatus}
                                                </Button> :
                                                <React.Fragment>
                                                    {
                                                        nextStatus === "QC sau ép" &&
                                                        <Button
                                                            type='primary'
                                                            className='float-right mt-5 ml-2'
                                                            onClick={this._updateStatus}
                                                        >
                                                            Chờ may
                                                        </Button>
                                                    }
                                                    <Button
                                                        type='primary'
                                                        className='float-right mt-5'
                                                        onClick={() => this._showModal('additional')}
                                                        disabled={nextStatus === "QC sau ép"}
                                                    >
                                                        {nextStatus}
                                                    </Button>
                                                </React.Fragment>
                                        )
                                    }
                                </div>
                            </div>
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}

                        {sewingThreadWarning && sewingThreadWarning.total_items > 0 &&
                            <SewingThreadWarning data={sewingThreadWarning} />
                        }
                    </Spin>

                    {/* {
                        showModal === 'giveSewName' && (<PopupConfirm
                            partner={partnerSewingId}
                            giveSewName={giveSewName}
                            visible={visible}
                            loading={updateLoading}
                            status={nextStatus}
                            nextStageName={nextStatus}
                            total={totalItems}
                            item={totalAvailableItemsNumber}
                            material_weight={material_weight}
                            onUpdate={this._updateStatus}
                            onClose={this._hiddenModal}
                            onChangeSelect={this._handleChangeSelect}
                            onChangeInput={this._handleChangeInput}
                        />)
                    } */}

                    {/* {
                        isSewedBatchs && showModal === 'receiveSewName' && (<PopupReceivedSewing
                            loading={updateLoading}
                            visible={visible}
                            receiveSewName={receiveSewName}
                            onUpdate={this._updateReceiveSewName}
                            onClose={this._hiddenModal}
                            onChangeInput={this._handleChangeInput}
                        />
                        )
                    } */}

                    {
                        showModal === 'additional' &&
                        <AdditionalModal
                            visible={visible}
                            loading={updateLoading}
                            status={nextBatchItemStageName}
                            message={nextStatus}
                            total={totalItems}
                            item={totalAvailableItemsNumber}
                            additional={additional}
                            additionalPayLoad={additionalPayLoad}
                            onUpdate={this._updateStatus}
                            onClose={this._hiddenModal}
                            onChangeAdditional={this._onChangeAdditional}
                            sewingThreadWarning={sewingThreadWarning}
                        />
                    }

                </div>
            </div>
        )
    }
}

export default withRouter(UpdateBatchesPageNew)
